export default __webpack_public_path__ + "static/media/faq3user.ffb01693.svg";